/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'sync-blue': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M14.43 4.867c.405-.228.918-.104 1.153.27 1.774 2.91 1.304 6.629-1.175 9.04a7.822 7.822 0 01-5.43 2.181 8.178 8.178 0 01-1.73-.187l.341.582a.828.828 0 01-.32 1.143c-.15.062-.278.104-.428.104-.299 0-.598-.145-.748-.416l-1.389-2.39a.771.771 0 01.021-.851l.064-.125a.936.936 0 01.706-.415L7.504 12.7c.427-.228.94-.104 1.176.312a.828.828 0 01-.321 1.143l-.748.415c1.966.458 4.104-.083 5.6-1.537 1.923-1.87 2.308-4.759.919-7.024a.827.827 0 01.3-1.143zM10.837.11a.878.878 0 011.176.311l1.389 2.39a.828.828 0 01-.32 1.143l-2.459 1.35c-.15.063-.277.104-.427.104-.3 0-.598-.145-.748-.415a.828.828 0 01.32-1.143l.877-.478c-2.052-.56-4.296-.041-5.857 1.475-1.923 1.87-2.308 4.759-.919 7.024a.827.827 0 01-.299 1.143.787.787 0 01-.427.125.815.815 0 01-.727-.416c-1.774-2.91-1.304-6.629 1.175-9.04a7.773 7.773 0 017.203-1.973l-.277-.457a.828.828 0 01.32-1.143z" _fill="#213F6B"/>'
  }
})
